export const OFFERS_LIST_KEY = 'OFFERS_LIST';
export const OFFERS_ONE_KEY = 'OFFERS_ONE_KEY';

export const OFFERS_PRODUCTS_RULE_LIST_KEY = 'OFFERS_PRODUCTS_RULE_LIST_KEY';

export const OFFERS_CATEGORY_RULE_LIST_KEY = 'OFFERS_CATEGORY_RULE_LIST_KEY';

export const ROTATION_PRODUCTS_LIST_KEY = 'ROTATION_PRODUCTS_LIST_KEY';

export const OFFERS_ACTIVITY_KEY = 'OFFERS_ACTIVITY_KEY';
